import ibanLib from "iban";
import React, { useState } from "react";
import {
  COUNTRY_SPECIFIC_REQUIREMENTS,
  CURRENT_COUNTRY_IN_PRODUCTION,
} from "../../../../../config/config";
import Text from "../../../../shared/components/Text";
import { notValidIBANReasons } from "../../DeclaredIncome/shared/constants/notValidIBANReasons";
import { sepaCountriesList } from "../../DeclaredIncome/shared/constants/sepaCountriesList";

export const useIBAN = ({ allowInternationalBorrower, forceCaixaBankIBAN }) => {
  const [notValidIBANReason, setNotValidIBANReason] = useState(undefined);

  const IBANValidationVariables = (IBAN) => {
    const notValidIBAN = !ibanLib.isValid(IBAN);
    const IBANCountryCode = IBAN.slice(0, 2);
    const isIBANInSepaList = sepaCountriesList.some(
      (country) => country.countryCode === IBANCountryCode
    );
    const notValidIBANForSepaCountry = notValidIBAN && isIBANInSepaList;
    const validNonSepaIBAN = ibanLib.isValid(IBAN) && !isIBANInSepaList;
    return {
      notValidIBAN,
      notValidIBANForSepaCountry,
      validNonSepaIBAN,
    };
  };

  const checkIBANValidation = (iban) => {
    if (iban) {
      const { notValidIBAN, notValidIBANForSepaCountry, validNonSepaIBAN } =
        IBANValidationVariables(iban);

      if (!allowInternationalBorrower && notValidIBAN)
        return <Text tId={"NOT_VALID_IBAN_FORMAT"} />;

      if (allowInternationalBorrower) {
        if (notValidIBANForSepaCountry) {
          return <Text tId={"NOT_VALID_IBAN_FORMAT"} />;
        }
        if (notValidIBAN) {
          setNotValidIBANReason(notValidIBANReasons.notValidIBANFormat);
          return <Text tId={"NOT_VALID_IBAN_FORMAT"} />;
        }
        if (validNonSepaIBAN) {
          setNotValidIBANReason(notValidIBANReasons.IBANNotInSepaList);
          return <Text tId={"IBAN_NOT_IN_SEPA_LIST"} />;
        }
        if (!notValidIBAN) setNotValidIBANReason(undefined);
      }
    }
  };

  const validateIfIBANIsSpanish = (IBAN) => {
    if (IBAN && !allowInternationalBorrower) {
      const BBAN = ibanLib.toBBAN(IBAN);
      const isIBANSpanish = ibanLib.isValidBBAN(
        COUNTRY_SPECIFIC_REQUIREMENTS[CURRENT_COUNTRY_IN_PRODUCTION].countryId,
        BBAN
      );
      if (!isIBANSpanish) {
        return COUNTRY_SPECIFIC_REQUIREMENTS[CURRENT_COUNTRY_IN_PRODUCTION].iban
          .message;
      }
    }
  };

  const validateIfIBANIsCaixabank = (IBAN) => {
    if (IBAN && forceCaixaBankIBAN) {
      const BBAN = ibanLib.toBBAN(IBAN);
      const bank = BBAN && BBAN.split(" ")[0];
      if (bank !== "2100") {
        return <Text tId={"INVALID_CAIXABANK_IBAN"} />;
      }
    }
  };
  return {
    checkIBANValidation,
    validateIfIBANIsSpanish,
    validateIfIBANIsCaixabank,
    notValidIBANReason,
  };
};
